import { initCommerceApiWithGlobals } from 'common-api';
import { isBrowser, logger } from 'common-ui';
import { authAtom } from '../../atoms/authAtom';
import { setRecoil } from 'recoil-nexus';
import type { AuthDetails } from 'tsconfig/types';
import { formatTokenResponseToAuthAtomState } from './formatTokenResponseToAuthAtomState';

export const reloadAuthToken = async (): Promise<AuthDetails | undefined> => {
  if (!isBrowser()) {
    logger.log('useReloadToken skipping as not in browser');
    return;
  }

  try {
    const commerceApi = initCommerceApiWithGlobals();
    const token = await commerceApi.Auth.reload();
    const newAuthValue = formatTokenResponseToAuthAtomState(token);
    setRecoil(authAtom, newAuthValue);
    return newAuthValue;
  } catch (e) {
    logger.error('PageReload ERROR', e);
    throw e;
  }
};
